<div style="padding-top:12px;padding-right:12px">
  <div nz-row [nzGutter]="['24','24']">
    <div nz-col nzSm="24" nzMd="24">
      <nz-select [(ngModel)]="type">
        <nz-option *ngFor="let option of listOfOption" [nzLabel]="option.label" [nzValue]="option.value"></nz-option>
      </nz-select>
    </div>
    <div nz-col nzSm="24" nzMd="24">
      <nz-tree
        #nzTreeComponent
        [nzData]="nodes"
        nzCheckable
        nzMultiple
        [nzCheckedKeys]="listKeyChecked"
        (nzClick)="nzClick($event)"
      >
      </nz-tree>
    </div>
  </div>
  <div *nzModalFooter>
    <button nz-button (click)="close($event)">Đóng</button>
    <button nz-button [nzSize]="'large'" nzType="primary" (click)="submit()">
      Chọn
    </button>
  </div>
</div>

